import styled from 'styled-components'

export const CharacterStyled = styled.div`
  .c-title {
    padding-top: 1rem;
    font-weight: bold;
  }
`
